export const COPPA_AGE_THRESHOLD = 13;

// Signup acknowledgment task keys
export const SIGNUP_TASKS = {
  ACCOUNT_TYPE_SELECTION: 'account_type_selection',
  COPPA_AGE_SCREENING: 'coppa_age_screening',
  PARENTAL_CONSENT: 'parental_consent',
  HOMESCHOOL_SCHOOL_SETUP: 'homeschool_school_setup',
  ACCOUNT_COMPLETION: 'account_completion',
  CONTENT_PERSONALIZATION: 'content_personalization'
} as const;

export interface PersonalInfoData {
  title?: string;
  firstName: string;
  lastName: string;
  username: string;
}

export interface SchoolData {
  schoolId?: string;
  homeschool?: {
    action: 'create' | 'join';
    name?: string;
    country?: string;
    city?: string;
    state?: string;
    schoolId?: string;
  };
}
